import { render, staticRenderFns } from "./MemberTreeChart.vue?vue&type=template&id=227db596&"
import script from "./MemberTreeChart.vue?vue&type=script&lang=js&"
export * from "./MemberTreeChart.vue?vue&type=script&lang=js&"
import style0 from "./MemberTreeChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports